var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#5B5A5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9999 22.92V31.09C38.9999 34.62 36.7289 37 33.3399 37H24.6699C21.2799 37 18.9999 34.62 18.9999 31.09V22.92C18.9999 19.38 21.2799 17 24.6699 17H33.3399C36.7289 17 38.9999 19.38 38.9999 22.92ZM28.2499 24.73V31.08C28.2499 31.5 28.5899 31.83 28.9999 31.83C29.4199 31.83 29.7499 31.5 29.7499 31.08V24.73L32.2199 27.21C32.3599 27.35 32.5599 27.43 32.7499 27.43C32.9389 27.43 33.1299 27.35 33.2799 27.21C33.5699 26.92 33.5699 26.44 33.2799 26.15L29.5299 22.38C29.2499 22.1 28.7499 22.1 28.4699 22.38L24.7199 26.15C24.4299 26.44 24.4299 26.92 24.7199 27.21C25.0199 27.5 25.4899 27.5 25.7899 27.21L28.2499 24.73Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreen);
export default __webpack_public_path__ + "static/media/share_screen.494d59471399be85db8e6d4c91c0d3df.svg";
export { ForwardRef as ReactComponent };